import React from "react";
import { ReviewServiceSvg, ThumbUpServiceSvg } from "../../components/Assets";
import OutlineBlueBtn2 from "../../components/buttons/OutlineBlueBtn2";
import { useNavigate } from "react-router-dom";

const PremiumServiceCards = () => {
  const navigate = useNavigate()
  return (
    <div className="flex items-center gap-2 overflow-x-scroll">
      <div className=" flex-shrink-0" style={{ width: 226 }}>
        <div
          style={{ height: 120 }}
          className="bg-lightblue2 flex justify-center items-center rounded-t-3xl"
        >
          <img src={ThumbUpServiceSvg} alt="thumb" />
        </div>
        <div className="text-darkblue p-6 border lite-border rounded-b-3xl">
          <div className=" text-lg font-bold mb-5">추천 댓글</div>
          <div style={{ height: 69 }} className="text-15">
            리뷰에 알맞은 댓글 초안을 추천해드려요.
          </div>

          <div>
            <OutlineBlueBtn2 onClick={()=>navigate("/review?time=IN_1_WEEKS&search_comment_reg_status_code=")} className="py-3 mt-7">일반 리뷰 보기</OutlineBlueBtn2>
          </div>
        </div>
      </div>

      <div className=" flex-shrink-0" style={{ width: 226 }}>
        <div
          style={{ height: 120 }}
          className="bg-purple flex justify-center items-center rounded-t-3xl"
        >
          <img src={ReviewServiceSvg} alt="thumb" />
        </div>
        <div className="text-darkblue p-6 border lite-border rounded-b-3xl">
          <div className=" text-lg font-bold mb-5">관심 리뷰 분류</div>
          <div style={{ height: 69 }} className="text-15">
            사장님이 꼭 보셔야 하는 고객의 중요한 피드백이나 악성 리뷰를
            분류해드려요.
          </div>

            <OutlineBlueBtn2 onClick={()=>navigate("/review/special?time=IN_1_WEEKS&search_comment_reg_status_code=")}  className="py-3 mt-7">관심 리뷰 보기</OutlineBlueBtn2>
        </div>
      </div>

      
    </div>
  );
};

export default PremiumServiceCards;
